import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { noop } from 'lodash-es';
import { useCoreIncentivesWizard } from 'site-modules/core-page/hooks/use-core-incentives-wizard';
import { IncentivesWizardEntities } from 'client/data/models/incentives-wizard';

export function CoreIncentivesWizardContent({
  incentives = null,
  setModelValue,
  zipCode = null,
  styleId,
  makeName,
  modelName,
  makeSlug,
  modelSlug,
  year,
  engineType = null,
  wizardState = undefined,
  onStartOver = noop,
  onFinish = noop,
  isUsed = false,
  isMobile = false,
}) {
  const engineTypes = [engineType?.toLowerCase()];

  const { openWizard, wizardWidgetCommonConfig, incentivesAmount, wizardDrawer } = useCoreIncentivesWizard({
    incentives,
    wizardState,
    styleId,
    year,
    makeSlug,
    modelSlug,
    makeName,
    modelName,
    engineTypes,
    isUsed,
    initialStepIndex: 0,
    setModelValue,
    onFinish,
    onStartOver,
    isMobile,
  });

  return (
    <div className="core-incentives-wizard">
      {!incentivesAmount && <div>No rebates available in {zipCode}</div>}
      {!!incentivesAmount && (
        <Fragment>
          <Button
            color="link"
            size="lg"
            className="text-transform-none text-blue-50 px-0 py-0 fw-normal"
            onClick={openWizard}
            data-tracking-id="view_ev_eligibility_wizard"
          >
            {wizardWidgetCommonConfig.btnCopy}
          </Button>
          {wizardDrawer}
        </Fragment>
      )}
    </div>
  );
}

CoreIncentivesWizardContent.propTypes = {
  incentives: IncentivesWizardEntities.IncentivesData,
  setModelValue: PropTypes.func.isRequired,
  styleId: PropTypes.number.isRequired,
  makeName: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
  makeSlug: PropTypes.string.isRequired,
  modelSlug: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  engineType: PropTypes.string,
  wizardState: IncentivesWizardEntities.IncentivesWizardUnwrappedPersistedState,
  onFinish: PropTypes.func,
  onStartOver: PropTypes.func,
  zipCode: PropTypes.string,
  isUsed: PropTypes.bool,
  isMobile: PropTypes.bool,
};
